export default "__VITE_ASSET__C8cg2Pze__"